import { CLIENT_CREATION_KEY_API, registerClientCreation } from './clientRegister';
import axios, { AxiosInstance } from 'axios';

export let preAuthApiClient: AxiosInstance = axios.create({
  baseURL: '/api/',
});

const create = (baseURL: string) => {
  preAuthApiClient = axios.create({
    baseURL,
  });
};

registerClientCreation(CLIENT_CREATION_KEY_API, create);
